import { PosTypeDtoToEntity } from "src/app/features/PosType/services/mappers/PosTypeDtoToEntity";
import type { PosTypeDto } from "src/app/features/PosType/types/PosTypeDto";
import type { PosTypeEntity } from "src/app/features/PosType/types/PosTypeEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const PosTypeTableDtoMapper = (input: Readonly<ResourcePageDto<PosTypeDto>>): ResourcePageEntity<PosTypeEntity> => {
    return {
        list: input.list ? input.list.map(PosTypeDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
